import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { BiReset } from 'react-icons/bi';

function OTPInput({ OTP, setOTP, reset }) {
  function moveFocus(e) {
    e.target.nextElementSibling.focus();
  }
  function movePrevFocus(e) {
    e.target.previousElementSibling.focus();
  }

  function handlePinDigitChange(e) {
    const re = /^[0-9\b]+$/;
    const element = e.target;
    let val = element.value;
    let id = element.id;

    if (val === '' || re.test(val)) {
      let temVal = [...OTP];
      switch (id) {
        case 'first':
          if (val.length > 0) {
            moveFocus(e);
          }

          temVal[0] = val;
          setOTP(temVal);
          break;
        case 'second':
          if (val.length > 0) {
            moveFocus(e);
          }
          if (val.length === 0) {
            movePrevFocus(e);
          }
          temVal[1] = val;
          setOTP(temVal);
          break;
        case 'third':
          if (val.length === 0) {
            movePrevFocus(e);
          }
          if (val.length === 1) {
            moveFocus(e);
          }

          temVal[2] = val;
          setOTP(temVal);
          break;
        case 'fourth':
          if (val.length === 0) {
            movePrevFocus(e);
          }
          temVal[3] = val;
          setOTP(temVal);
          break;
        default:
          break;
      }
    } else {
      element.value = '';
    }
  }

  const resetOTP = () => {
    setOTP([]);
    input1Ref.current.focus();
    input1Ref.current.value = '';
    input2Ref.current.value = '';
    input3Ref.current.value = '';
    input4Ref.current.value = '';
  };

  const input1Ref = useRef();
  const input2Ref = useRef();
  const input3Ref = useRef();
  const input4Ref = useRef();

  useEffect(() => {
    if (reset) reset.current = resetOTP;
  }, [OTP]);
  return (
    <StyleOTPInput id="otp" className="inputs d-flex">
      {' '}
      <input
        className="m-2 text-center form-control border-secondary rounded"
        id="first"
        autoFocus
        ref={input1Ref}
        maxLength={1}
        onChange={handlePinDigitChange}
      />{' '}
      <input
        className="m-2 text-center form-control border-secondary rounded"
        id="second"
        ref={input2Ref}
        maxLength={1}
        onChange={handlePinDigitChange}
      />{' '}
      <input
        className="m-2 text-center form-control border-secondary rounded"
        id="third"
        ref={input3Ref}
        maxLength={1}
        onChange={handlePinDigitChange}
      />{' '}
      <input
        className="m-2 text-center form-control border-secondary rounded"
        id="fourth"
        ref={input4Ref}
        maxLength={1}
        onChange={handlePinDigitChange}
      />{' '}
      <ResetButtonContainer>
        <div className="resetBtn" onClick={resetOTP}>
          <BiReset size="24" color="red" />
        </div>
      </ResetButtonContainer>
    </StyleOTPInput>
  );
}

export default OTPInput;

const StyleOTPInput = styled.div`
  input {
    width: 50px;
  }
`;

const ResetButtonContainer = styled.span`
  display: flex;
  align-items: start;
  .resetBtn {
    cursor: pointer;
    svg {
      color: '#e93f4a';
    }
  }
`;
